export default {
    UPCOMING: 'upcoming',
    THISMONTH: 'thismonth',
    THISYEAR: 'thisyear',
    ARCHIVED: 'archived',
    ALL: 'all'
}